<template>
  <div>
    <div class="row">
      <div class="col-md-6 date-range">
        Rango de búsqueda:
        <date-picker
          v-model="dateRange"
          format="DD/MM/YYYY"
          lang="es"
          :shortcuts="false"
          range
          confirm
          @clear="clearDates"
          @confirm="datesChanged"
        />
      </div>
      <div class="col-md-6 geolocalization-provider">
        <span>Proveedor de geolocalizacion:</span>
        <select v-model="selectedProvider" @change="onChangeGeocodingProvider">
          <option
            v-for="provider in geocodeProviders"
            :key="provider.value"
            :value="provider.value"
          >{{ provider.name }}</option>
        </select>
      </div>
    </div>
    <vue-good-table
      :columns="columnsValues"
      :rows="currentSignals"
      :line-numbers="true"
      styleClass="vgt-table bordered"
      @on-row-click="showRow"
      :pagination-options="{
        enabled: true,
        perPage: '15',
        perPageDropdown: [15],
        mode: 'records',
        rowsPerPageLabel: 'Reportes por página',
        ofLabel: 'de',
        allLabel: 'Todas',
        prevLabel: 'Anterior',
        nextLabel: 'Siguiente'
      }"
    >
      <div slot="emptystate">No existen resultados</div>
    </vue-good-table>
  </div>
</template>

<script>
import GoogleMapsLoader from "google-maps";
import DatePicker from "vue2-datepicker";
import GeocodeService, { GeocodeProvider } from "src/services/geocoding";

const geocodeProvidersNames = {
  [GeocodeProvider.Google]: "Google",
  [GeocodeProvider.ClickGo]: "ClickGo",
  [GeocodeProvider.Nominatim]: "Nominatim"
};

const geocodeProviders = Object.values(GeocodeProvider).map(provider => ({
  value: provider,
  name:
    provider in geocodeProvidersNames
      ? geocodeProvidersNames[provider]
      : provider
}));

export default {
  components: {
    DatePicker
  },

  props: {
    car: null,
    currentSignals: null,
    rowsPerPage: null
  },

  data() {
    return {
      dateRange: [],
      selectedProvider: null,
      geocodeProviders,
      columnsValues: [
        {
          label: "Fecha y Hora",
          field: "datetime",
          sortable: false,
          tdClass: "text-center",
          width: "150px",
          placeholder: "Filtrar por fecha"
        },
        {
          label: "Ubicación",
          field: "address",
          sortable: false,
          tdClass: "text-center",
          width: "200px",
          placeholder: "Filtrar por ubicación"
        },
        {
          label: "Velocidad",
          sortable: false,
          field: "speed",
          type: "number",
          tdClass: "text-center",
          placeholder: "Filtrar por velocidad"
        },
        {
          label: "Rumbo",
          sortable: false,
          field: this.heading_text,
          tdClass: "text-center",
          placeholder: "Filtrar por rumbo"
        },
        {
          label: "Evento",
          sortable: false,
          field: this.event_text,
          tdClass: "text-center",
          placeholder: "Filtrar por evento"
        },
        {
          label: "Online",
          sortable: false,
          field: this.online_text,
          tdClass: "online",
          placeholder: "Filtrar por estado"
        },
        {
          label: "Antena",
          sortable: false,
          field: this.antenna_state_ok_text,
          tdClass: "text-center",
          placeholder: "Filtrar por estado de la antena"
        }
      ],
      myGeocoder: null,
      mostrarDatos: false,
      data: this.currentSignals
    };
  },

  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
    isPlain() {
      return this.type === "plain";
    }
  },

  watch: {
    currentSignals(val) {
      this.$forceUpdate();
    }
  },

  created() {
    this.selectedProvider = GeocodeService.getProvider();
  },

  methods: {
    hasValue(item, column) {
      var aux = column.replace(/\s+/g, "");
      return item[aux.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      var aux = column.replace(/\s+/g, "");
      return item[aux.toLowerCase()];
    },
    showRow(params) {
      this.$emit("focus-location", params.row.index);
    },
    pageChange(info) {
      this.$emit("page-change", info.currentPage);
    },

    online_text: function(rowObj) {
      var minutes = Math.floor(rowObj.online_timestamp / 60);
      var seconds = rowObj.online_timestamp - minutes * 60;
      return minutes + ":" + Math.round(seconds);
    },

    antenna_state_ok_text: function(rowObj) {
      if (rowObj.antenna_state_ok) return "Ok";
      else return "COLGADA";
    },

    event_text: function(rowObj) {
      switch (rowObj.event) {
        case "stationary_contact_off":
          return "Estacionado - Sin contacto";
          break;
        case "contact_on":
          return "En contacto";
          break;
        case "in_motion_contact_on":
          return "Movimiento - En contacto";
          break;
        case "motion_initiated":
          return "Movimiento iniciado";
          break;
        default:
          return rowObj.event;
      }
    },

    heading_text: function(rowObj) {
      var norte = [0, 22];
      var noreste = [23, 68];
      var este = [69, 112];
      var sureste = [113, 158];
      var sur = [159, 202];
      var suroeste = [203, 248];
      var oeste = [249, 292];
      var noroeste = [293, 337];
      var norte2 = [338, 360];
      var cardinal_points = {
        Norte: norte,
        "Norte ": norte2,
        Noreste: noreste,
        Este: este,
        Sureste: sureste,
        Sur: sur,
        Suroeste: suroeste,
        Oeste: oeste,
        Noroeste: noroeste
      };
      var result = " ";
      Object.keys(cardinal_points).forEach(function(key) {
        if (
          cardinal_points[key][0] <= rowObj.heading &&
          cardinal_points[key][1] >= rowObj.heading
        ) {
          result = key;
        }
      });
      return result;
    },

    clearDates() {
      this.$emit("clear-dates");
    },

    datesChanged(dates) {
      this.$emit("change-dates", dates[0], dates[1]);
    },

    onChangeGeocodingProvider(event) {
      this.$emit("change-geocode-provider", event.target.value);
    }
  }
};
</script>

<style <style lang="scss">
/* Magic for scroll table */
.table-fixed thead {
  width: 100%;
}
.table-fixed tbody {
  height: 350px;
  overflow-y: auto;
  width: 100%;
}
.table-fixed thead,
.table-fixed tbody,
.table-fixed tr,
.table-fixed td,
.table-fixed th {
  display: block;
}
.table-fixed tbody td,
.table-fixed thead > tr > th {
  float: left;
  border-bottom-width: 0;
}

.date-range {
  padding: 10px;
}

.geolocalization-provider {
  padding: 10px;
  display: block;
  align-items: center;

  & span {
    margin-right: 5px;
  }

  & select {
    height: 34px;
    border-radius: 4px;
    background: white;
    border: 1px solid #ccc;
    width: 100%;
    max-width: 320px;
  }
}
</style>



// WEBPACK FOOTER //
// LocationTable.vue?6fdff45f